import React, { ReactNode } from "react";
import { Card, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";

interface DashboardCardProps {
  title: string;
  description: string;
  icon: ReactNode;
  href: string;
  count?: number;
  badge?: string;
  badgeColor?: string;
}

export function DashboardCard({
  title,
  description,
  icon,
  href,
  count,
  badge,
  badgeColor = "bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-400",
}: DashboardCardProps) {
  return (
    <Link to={href}>
      <Card className="h-full bg-white dark:bg-gray-950 border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-md transition-shadow duration-200 hover:border-blue-200 dark:hover:border-blue-800">
        <CardContent className="p-6">
          <div className="flex items-start justify-between">
            <div className="flex items-center space-x-4">
              <div className="p-2 bg-blue-50 dark:bg-blue-900/20 rounded-full">
                {icon}
              </div>
              <div>
                <h3 className="font-medium text-gray-900 dark:text-gray-100 mb-1 flex items-center">
                  {title}
                  {badge && (
                    <Badge
                      className={`ml-2 text-[10px] font-medium py-0.5 ${badgeColor}`}
                    >
                      {badge}
                    </Badge>
                  )}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400">
                  {description}
                </p>
              </div>
            </div>
            {count !== undefined && (
              <div className="bg-gray-100 dark:bg-gray-800 h-8 w-8 rounded-full flex items-center justify-center text-sm font-medium text-gray-700 dark:text-gray-300">
                {count}
              </div>
            )}
          </div>
        </CardContent>
      </Card>
    </Link>
  );
}
